import { AdditionalTreatmentCard } from './AdditionalTreatmentCard';
import {
  ADDITIONAL_TREATMENT_STATES,
  type AdditionalTreatmentItem,
} from './types';

export type AdditionalTreatmentCardsProps = {
  treatments: AdditionalTreatmentItem[];
};

const STATE_ORDER: Record<
  (typeof ADDITIONAL_TREATMENT_STATES)[keyof typeof ADDITIONAL_TREATMENT_STATES],
  number
> = {
  [ADDITIONAL_TREATMENT_STATES.AVAILABLE_FOR_REFILL]: 0,
  [ADDITIONAL_TREATMENT_STATES.PRESCRIPTION_ISSUED]: 1,
  [ADDITIONAL_TREATMENT_STATES.REQUEST_SUBMITTED]: 2,
  [ADDITIONAL_TREATMENT_STATES.AVAILABLE]: 3,
  [ADDITIONAL_TREATMENT_STATES.LOCKED]: 4,
  [ADDITIONAL_TREATMENT_STATES.LOCKED_BEFORE_CONSULT]: 4,
  [ADDITIONAL_TREATMENT_STATES.LOCKED_WAITING_REFILL]: 4,
};

/**
 * The list of Additional Treatment cards on their own — sorted by state
 * priority. Reusable outside the `AdditionalTreatmentsList` "Expanded Care"
 * container (e.g. on the prep-seq landing page).
 */
export const AdditionalTreatmentCards = ({
  treatments,
}: AdditionalTreatmentCardsProps) => {
  if (treatments.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-xs">
      {[...treatments]
        .sort((a, b) => STATE_ORDER[a.state] - STATE_ORDER[b.state])
        .map((treatment) => (
          <AdditionalTreatmentCard key={treatment.id} treatment={treatment} />
        ))}
    </div>
  );
};
